// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__2DD-w","label":"SetPasswdForm_label__29of9"};